// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_THEME = '@customization/SET_THEME';
export const SET_CUSTOMIZE = '@customization/SET_CUSTOMIZE';

export const SET_CONFIGURATION = '@configuration/SET_CONFIGURATION';

export const SNACKBAR_ACTIVE = '@snackbar/SET_ACTIVE';
export const SNACKBAR_INACTIVE = '@snackbar/SET_INACTIVE';

export const LOADING_ACTIVE = '@loading/SET_ACTIVE';
export const LOADING_INACTIVE = '@loading/SET_INACTIVE';

export const SET_PERMISSIONS = '@permissions/SET_PERMISSIONS'

export const SET_LIST_QUERY = '@log/SET_LIST_QUERY'
export const SET_LOG_PATHNAME = '@log/SET_LOG_PATHNAME'

export const DIALOG_ACTIVE = '@dialog/DIALOG_ACTIVE'